var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-574.000000, -2575.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "icon-bg-remove",
    points: "578 2578.33341 574.666588 2575 574 2575.66659 577.333412 2579 574 2582.33341 574.666588 2583 578 2579.66659 581.333412 2583 582 2582.33341 578.666588 2579 582 2575.66659 581.333412 2575"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBgRemove);
export default __webpack_public_path__ + "static/media/icon-bg-remove.2f44cb641d0464b3342af190c41b13ea.svg";
export { ForwardRef as ReactComponent };